import { useApp } from '@/core/state/appStore'
import { isCategoryFilterActive } from '@/core/lib/viewInput'
import type { FilterMenuRow } from '@/core/components/dashboard/FilterMenu'
import { excludedByCategoryFromMemberFilter, memberViewConfig } from './memberViewConfig'

export function useMemberFilterRows(): { rows: FilterMenuRow[]; active: boolean } {
  const { state, dispatch } = useApp()
  const filter = state.memberViewFilter
  const excludedByCategory = excludedByCategoryFromMemberFilter(filter)
  const toggleIn = (list: string[], value: string) =>
    list.includes(value) ? list.filter((v) => v !== value) : [...list, value]

  const rows: FilterMenuRow[] = (memberViewConfig.filterCategories ?? []).map((cat) => ({
    kind: 'options',
    id: cat.id,
    label: cat.label,
    options: cat.catalog([]),
    excluded: excludedByCategory[cat.id] ?? [],
    count: (excludedByCategory[cat.id] ?? []).length,
    onToggle: (key) => {
      const current = excludedByCategory[cat.id] ?? []
      const next = toggleIn(current, key)
      dispatch({
        type: 'SET_MEMBER_VIEW_FILTER',
        filter: cat.id === 'rolle' ? { excludedRolle: next } : { excludedStatus: next },
      })
    },
  }))

  return { rows, active: isCategoryFilterActive(excludedByCategory) }
}
